import $ from 'jquery'
import serializeForm from "./serialize-form";
import Pristine from "pristinejs";

let ProductEnquiry = {
  Initalised : false,
  
}

ProductEnquiry.init = function()
{
  if(!this.Initalised)
  {
    this.Initalised = true;
  }else{
    return false;
  }

  this.productEnquiryForm = document.getElementById("product-enquiry-form");
  

  
  if(this.productEnquiryForm){
    $('#form-field-product').val($('#product-to-copy').val());
  
  }
  

}

/*ProductEnquiry.submit = function(){


  if(!this.pristine.validate()){
    return;
  }

  var errorDiv = document.getElementById('product-enquire-from-error');
  errorDiv.classList.remove('show');
  var successDiv = document.getElementById('product-enquire-from-success');
  successDiv.classList.remove('show');
  var data = serializeForm(this.productEnquiryForm);
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = () => {

    if (xhr.readyState === 4 && xhr.status === 200) {

      var r = JSON.parse(xhr.response);
      if(r.error){
        var errorDiv = document.getElementById('product-enquire-from-error');
        errorDiv.classList.add('show');
      }else{
        this.productEnquiryForm.reset();
        var successDiv = document.getElementById('product-enquire-from-success');
        successDiv.classList.add('show');
      }
    };

  }

  xhr.open('POST', "/wp-admin/admin-ajax.php?action=product_enquiry");
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  xhr.send(data);
}*/

export default ProductEnquiry;


// WEBPACK FOOTER //
// ./resources/assets/js/components/productenquiry.js